module.exports = __webpack_public_path__ + "1b2971c690ed9b994cc5ffe7702a0127.svg";